// CORE
import { useState } from "react";

// THIRD-PARTY LIBRARIES
import { DragDropContext } from "react-beautiful-dnd";
import { Col, Row } from "react-bootstrap";
import { v4 as uuidv4 } from "uuid"; // Added for unique IDs

// COMPONENTS
import Controls, { controls } from "./Controls";
import FormData from "./Form";
import FormWrapper from "components/Form/form-wrapper";

function FormBuilder({ formObject, setFormObject }) {
    // Ensure formObject is always an array, default to empty array if undefined
    const [formData, setFormData] = useState(
        Array.isArray(formObject) ? formObject : []
    );

    // Handle drag-and-drop logic
    const onDragEnd = (result) => {
        const { draggableId, source, destination } = result;

        // Skip if there's no valid destination
        if (!destination) return;

        if (source.droppableId === "controls_droppable") {
            // Add new control from Controls list
            const control = controls.find((event) => event.type === draggableId);
            if (!control) return; // Guard against undefined control

            const newFormControl = {
                id: uuidv4(), // Use UUID for unique, reliable IDs
                ...control,
            };

            const newFormData = [...formData];
            newFormData.splice(destination.index, 0, newFormControl);
            setFormData(newFormData);
            setFormObject(newFormData); // Sync with parent state
        } else if (source.droppableId === "form_droppable") {
            // Reorder existing form fields
            if (source.index === destination.index) return; // No change needed

            const newFormData = [...formData];
            const [movedFormControl] = newFormData.splice(source.index, 1);
            newFormData.splice(destination.index, 0, movedFormControl);
            setFormData(newFormData);
            setFormObject(newFormData); // Sync with parent state
        }
    };

    return (
        <DragDropContext onDragEnd={onDragEnd}>
            <Row>
                <Col xs={12} md={6}>
                    <Controls />
                </Col>
                <Col xs={12} md={6}>
                    <FormWrapper>
                        <FormData
                            formData={formData}
                            updateFormData={setFormData}
                        />
                    </FormWrapper>
                </Col>
            </Row>
        </DragDropContext>
    );
}

export default FormBuilder;
